module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 600,
	"w": 1200,
	"h": 1200,
	"nm": "Publisher_page_header_animation_blue_noMasks",
	"ddd": 0,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "LabilGrotesk-Bold",
				"fFamily": "Labil Grotesk",
				"fStyle": "Bold",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 5,
			"nm": "FRICTION",
			"parent": 7,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						2.857,
						7.057,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-16,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						85,
						85,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 62,
								"f": "LabilGrotesk-Bold",
								"t": "FRICTION",
								"j": 2,
								"tr": 0,
								"lh": 74.4,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 5,
			"nm": "FREE",
			"parent": 8,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						-0.143,
						11.057,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-12,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						85,
						85,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 62,
								"f": "LabilGrotesk-Bold",
								"t": "FREE",
								"j": 2,
								"tr": 0,
								"lh": 74.4,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 5,
			"nm": "COMMERCE ",
			"parent": 9,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						2.857,
						7.057,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-19,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						85,
						85,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 62,
								"f": "LabilGrotesk-Bold",
								"t": "COMMERCE",
								"j": 2,
								"tr": 0,
								"lh": 74.4,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Friction black",
			"parent": 7,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									315,
									315
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.105882354081,
									0.105882354081,
									0.105882354081,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Free black",
			"parent": 8,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									249,
									249
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.105882354081,
									0.105882354081,
									0.105882354081,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Commerce black",
			"parent": 9,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									368,
									368
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.105882354081,
									0.105882354081,
									0.105882354081,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "Friction spot",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 0,
							"s": [
								198.577,
								263.799,
								0
							],
							"to": [
								120.91,
								123.804,
								0
							],
							"ti": [
								-168.405,
								175.847,
								0
							]
						},
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 300,
							"s": [
								935.812,
								310.71,
								0
							],
							"to": [
								-180.697,
								185.418,
								0
							],
							"ti": [
								123.333,
								127.333,
								0
							]
						},
						{
							"t": 599,
							"s": [
								198.577,
								263.799,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									320.858,
									320.858
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "Free spot",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 0,
							"s": [
								885.163,
								485.314,
								0
							],
							"to": [
								-155.964,
								56.159,
								0
							],
							"ti": [
								233.017,
								-83.904,
								0
							]
						},
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 300,
							"s": [
								272.17,
								664.067,
								0
							],
							"to": [
								-16.223,
								5.842,
								0
							],
							"ti": [
								23.259,
								-8.375,
								0
							]
						},
						{
							"t": 599,
							"s": [
								885.163,
								485.314,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									254.552,
									254.552
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 9,
			"ty": 4,
			"nm": "Commerce Spot",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 0,
							"s": [
								209.163,
								921.314,
								0
							],
							"to": [
								195.637,
								-299.851,
								0
							],
							"ti": [
								-194.601,
								-143.742,
								0
							]
						},
						{
							"i": {
								"x": 0.5,
								"y": 1
							},
							"o": {
								"x": 0.5,
								"y": 0
							},
							"t": 300,
							"s": [
								980,
								816,
								0
							],
							"to": [
								-202.561,
								-147.243,
								0
							],
							"ti": [
								196.468,
								-305.081,
								0
							]
						},
						{
							"t": 600,
							"s": [
								209.163,
								921.314,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									374.254,
									374.254
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 4,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 657,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "C",
			"size": 62,
			"style": "Bold",
			"w": 77.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.645,
												0
											],
											[
												-0.201,
												16.818
											],
											[
												0,
												0
											],
											[
												10.373,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.884,
												0
											],
											[
												-0.403,
												-9.467
											],
											[
												0,
												0
											],
											[
												19.135,
												0
											],
											[
												0,
												-20.847
											]
										],
										"o": [
											[
												19.235,
												0
											],
											[
												0,
												0
											],
											[
												-0.604,
												9.869
											],
											[
												-12.085,
												0
											],
											[
												0,
												-13.495
											],
											[
												10.675,
												0
											],
											[
												0,
												0
											],
											[
												-0.302,
												-16.617
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												39.981,
												1.913
											],
											[
												74.524,
												-27.997
											],
											[
												58.813,
												-29.205
											],
											[
												39.981,
												-12.589
											],
											[
												19.537,
												-35.248
											],
											[
												39.981,
												-58.109
											],
											[
												58.813,
												-41.895
											],
											[
												74.625,
												-43.204
											],
											[
												39.981,
												-72.409
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "C",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "O",
			"size": 62,
			"style": "Bold",
			"w": 80.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.847,
												0
											],
											[
												0,
												20.847
											],
											[
												20.847,
												0
											],
											[
												0,
												-20.746
											]
										],
										"o": [
											[
												21.048,
												0
											],
											[
												0,
												-21.048
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												40.384,
												2.014
											],
											[
												77.646,
												-35.248
											],
											[
												40.384,
												-72.51
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												11.581,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.581,
												0
											],
											[
												0,
												-13.293
											]
										],
										"o": [
											[
												-11.783,
												0
											],
											[
												0,
												-13.495
											],
											[
												11.783,
												0
											],
											[
												0,
												13.394
											]
										],
										"v": [
											[
												40.384,
												-12.488
											],
											[
												19.537,
												-35.248
											],
											[
												40.384,
												-58.109
											],
											[
												61.23,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "O",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "M",
			"size": 62,
			"style": "Bold",
			"w": 88.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.746,
												0
											],
											[
												19.739,
												-50.253
											],
											[
												36.255,
												0
											],
											[
												52.57,
												0
											],
											[
												69.186,
												-50.253
											],
											[
												68.179,
												0
											],
											[
												83.89,
												0
											],
											[
												83.89,
												-70.496
											],
											[
												61.533,
												-70.496
											],
											[
												44.513,
												-16.315
											],
											[
												27.594,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "M",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "M",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "E",
			"size": 62,
			"style": "Bold",
			"w": 58.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												55.087,
												0
											],
											[
												55.087,
												-12.891
											],
											[
												21.35,
												-12.891
											],
											[
												21.35,
												-29.608
											],
											[
												51.059,
												-29.608
											],
											[
												51.059,
												-41.592
											],
											[
												21.35,
												-41.592
											],
											[
												21.35,
												-57.806
											],
											[
												54.684,
												-57.806
											],
											[
												54.684,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "E",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "R",
			"size": 62,
			"style": "Bold",
			"w": 64.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.403,
												-6.143
											],
											[
												0,
												0
											],
											[
												-0.604,
												-1.611
											],
											[
												0,
												0
											],
											[
												0.201,
												3.323
											],
											[
												0,
												0
											],
											[
												9.567,
												0.705
											],
											[
												0,
												9.467
											],
											[
												15.61,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												6.345,
												0
											],
											[
												0,
												0
											],
											[
												0.201,
												2.115
											],
											[
												0,
												0
											],
											[
												-0.806,
												-1.813
											],
											[
												0,
												0
											],
											[
												-0.504,
												-8.56
											],
											[
												10.776,
												-1.108
											],
											[
												0,
												-12.689
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.149,
												0
											],
											[
												21.149,
												-23.566
											],
											[
												32.529,
												-23.566
											],
											[
												42.599,
												-15.408
											],
											[
												43.204,
												-5.942
											],
											[
												44.312,
												0
											],
											[
												60.626,
												0
											],
											[
												59.317,
												-7.15
											],
											[
												58.713,
												-16.617
											],
											[
												44.211,
												-31.018
											],
											[
												62.64,
												-49.045
											],
											[
												36.154,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-6.345
											],
											[
												6.546,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												6.445,
												0
											],
											[
												0,
												6.244
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												21.149,
												-36.255
											],
											[
												21.149,
												-57.605
											],
											[
												35.349,
												-57.605
											],
											[
												46.326,
												-46.93
											],
											[
												35.147,
												-36.255
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "R",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "F",
			"size": 62,
			"style": "Bold",
			"w": 54.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.35,
												0
											],
											[
												21.35,
												-27.997
											],
											[
												50.354,
												-27.997
											],
											[
												50.354,
												-40.485
											],
											[
												21.35,
												-40.485
											],
											[
												21.35,
												-57.605
											],
											[
												52.368,
												-57.605
											],
											[
												52.368,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "F",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "I",
			"size": 62,
			"style": "Bold",
			"w": 27.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.841,
												0
											],
											[
												21.954,
												0
											],
											[
												21.954,
												-70.496
											],
											[
												5.841,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "I",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "T",
			"size": 62,
			"style": "Bold",
			"w": 60,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												22.055,
												0
											],
											[
												38.37,
												0
											],
											[
												38.37,
												-57.605
											],
											[
												58.109,
												-57.605
											],
											[
												58.109,
												-70.496
											],
											[
												2.316,
												-70.496
											],
											[
												2.316,
												-57.605
											],
											[
												22.055,
												-57.605
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "T",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "N",
			"size": 62,
			"style": "Bold",
			"w": 71.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.847,
												0
											],
											[
												20.041,
												-47.534
											],
											[
												50.354,
												0
											],
											[
												66.769,
												0
											],
											[
												66.769,
												-70.496
											],
											[
												50.958,
												-70.496
											],
											[
												51.764,
												-22.961
											],
											[
												21.451,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "N",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/Publisher_page_header_animation_noMasks.json
// module id = 57
// module chunks = 0